import StencilHTMLElement from "./stencil-element";
import {
  differenceInDays, differenceInHours, differenceInMinutes,
  differenceInSeconds, subDays, subHours, subMinutes, isBefore
} from 'date-fns'

class CountdownTimer extends StencilHTMLElement {
  name = "CountdownTimer";
  element;
  #interval;

  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this.querySelector(".countdown");
    // setInterval needs to know the context around it in order to fetch the element.
    // Maybe move everything into this.#update() to avoid binding? What's the best practice?
    this.#interval = setInterval(this.#update.bind(this), 1000); 
    this.#update();
  }

  #update() {
    let now = new Date();
    let relativeEnd = new Date(this.element.dataset.countdownEnd * 1000);
    let format = this.element.dataset.countdownFormat;

    if (format == "d-h-m-s") {
      let diffDays = differenceInDays(relativeEnd, now);
      this.element.querySelector(".countdown-days").innerText = diffDays;
      relativeEnd = subDays(relativeEnd, diffDays);
    }

    let diffHours = differenceInHours(relativeEnd, now);
    this.element.querySelector(".countdown-hours").innerText = diffHours;
    relativeEnd = subHours(relativeEnd, diffHours);

    let diffMins = differenceInMinutes(relativeEnd, now);
    this.element.querySelector(".countdown-minutes").innerText = ("00" + diffMins).slice(-2);
    relativeEnd = subMinutes(relativeEnd, diffMins);

    let diffSecs = differenceInSeconds(relativeEnd, now);
    this.element.querySelector(".countdown-seconds").innerText = ("00" + diffSecs).slice(-2);

    if (isBefore(relativeEnd, now)) {
      this.element.parentNode.removeChild(this.element);
      clearInterval(this.#interval);
    }
  }
}

export default CountdownTimer;